import React, { Component } from 'react';
import { Segment, Container } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import { Chart } from 'react-google-charts';
import { toWapi } from '../../util/api';

class Analytic extends Component {
	state = {
		filterType: false,
		filterAgent: false,
		loading: true,
		start_date: this.props.start_date,
		end_date: this.props.end_date,
		today: moment(),
		group: ['agent'],
		pid: this.props.product.maytapi.settings.live.token,
		phonepid: this.props.product.maytapi.settings.wapi_pid || this.props.product.maytapi.id,
		selectedAgent: 'all',
		selectedDate: 'daily',
		productAgentList: [],
		botId: '',
		tableStart: 0,
		tableEnd: 20,
		dataloading: true,
	};
	_i = 0;
	componentDidUpdate(oldProps, oldState) {
		const check_list = ['start_date', 'end_date', 'selectedAgent'];
		for (let i = 0; i < check_list.length; i++) {
			const key = check_list[i];
			if (key === 'start_date' || key === 'end_date') {
				if (this.props[key] !== oldProps[key]) {
					this.getData()();
					break;
				}
			}
			if (this.state[key] !== oldState[key]) {
				this.getData()();
				break;
			}
		}
	}
	componentDidMount() {
		let { pid, phonepid, end_date, start_date } = this.state;
		let product = this.props.product.maytapi;
		let isMock = product && product.settings.mock_analytic;
		console.log(isMock);
		let token = product && product.settings && product.settings.wapi_token;
		if (token) {
			toWapi(`/api/${phonepid}/listPhones`, product.settings.wapi_token)
				.then((data) => {
					if (data.status !== 200) {
						return;
					}
					let phonedata = _.filter(data.data, function (it) {
						return it.type === 'whatsapp';
					});
					let instagramdata = _.filter(data.data, function (it) {
						return it.type === 'instagram';
					});
					this.setState({
						phones: _.map(phonedata, function (it) {
							return {
								phone: it.id,
								type: it.type,
							};
						}),
						instagrams: _.map(instagramdata, function (it) {
							return {
								phone: it.id,
								type: it.type,
							};
						}),
					});
				})
				.catch((err) => {
					console.error(err);
				});
			fetch('https://log.maytapi.com/analytic/timeline/phone', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					start_date: start_date,
					end_date: end_date,
					pid: phonepid,
				}),
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					let newData = _.map(data, (it) => ({
						phone: it.phone,
						last_status: it.last_status,
						changes: it.changes
							? _.filter(
									_.map(it.changes, function (a, i) {
										if (i === 0) {
											return a;
										} else {
											if (it.changes[i - 1].status !== it.changes[i].status) {
												return a;
											}
										}
									}),
									function (o) {
										return o && o.date;
									}
							  )
							: [],
					}));
					console.log('newData', newData);
					this.setState({ phoneStatus: newData, phoneLength: data.length });
				});
		}

		fetch('https://log.maytapi.com/live/timeline/agent ', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				pid: pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let newData = _.map(data, (it) => ({
					agent: it.agent,
					last_status: it.last_status,
					changes: it.changes
						? _.filter(
								_.map(it.changes, function (a, i) {
									if (i === 0) {
										return a;
									} else {
										if (it.changes[i - 1].status !== it.changes[i].status) {
											return a;
										}
									}
								}),
								function (o) {
									return o && o.date;
								}
						  )
						: [],
				}));
				this.setState({ agentStatus: newData, loading: false, agentLength: data.length });
			});
	}
	getData = (value) => async () => {
		let { start_date, end_date } = this.props;
		let product = this.props.product.maytapi;
		let { pid, phonepid } = this.state;
		let token = product && product.settings && product.settings.wapi_token;
		this.setState({ loading: true });
		if (token) {
			await fetch('https://log.maytapi.com/analytic/timeline/phone', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					start_date: start_date,
					end_date: end_date,
					pid: phonepid,
				}),
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					let newData = _.map(data, (it) => ({
						phone: it.phone,
						last_status: it.last_status,
						changes: it.changes
							? _.filter(
									_.map(it.changes, function (a, i) {
										if (i === 0) {
											return a;
										} else {
											if (it.changes[i - 1].status !== it.changes[i].status) {
												return a;
											}
										}
									}),
									function (o) {
										return o && o.date;
									}
							  )
							: [],
					}));

					this.setState({ phoneStatus: newData, phoneLength: data.length });
				});
		}
		await fetch('https://log.maytapi.com/live/timeline/agent ', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				pid: pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let newData = _.map(data, (it) => ({
					agent: it.agent,
					last_status: it.last_status,
					changes: _.filter(
						_.map(it.changes, function (a, i) {
							if (i === 0) {
								return a;
							} else {
								if (it.changes[i - 1].status !== it.changes[i].status) {
									return a;
								}
							}
						}),
						function (o) {
							return o && o.date;
						}
					),
					changesno: _.map(it.changes, function (a, i) {
						if (i === 0) {
							return a;
						} else {
							if (it.changes[i - 1].status !== it.changes[i].status) {
								return a;
							}
						}
					}),
				}));
				this.setState({ agentStatus: newData, loading: false, agentLength: data.length });
			});
	};
	dateChange = ({ selection }) => {
		let start_date = moment(selection.startDate).startOf('day');
		let end_date = moment(selection.endDate);
		if (end_date.format('YYYY-MM-DD') !== this.state.today.format('YYYY-MM-DD')) {
			end_date = end_date.endOf('day');
		} else {
			end_date = moment();
		}
		this.setState({ start_date, end_date });
	};
	render() {
		let { start_date, end_date } = this.props;
		if (this.state.loading)
			return (
				<Container>
					<Segment style={{ marginBottom: '20px' }}>
						<Page.Loader></Page.Loader>
					</Segment>
				</Container>
			);
		let timelineData = [],
			phoneTimeline = [],
			instagramTimeline = [];
		let colorsphone = {
			active: '#4ed34e',
			idle: '#fbbd08',
			'qr-screen': '#f2711c',
			'phone-error': '#d34e4e',
			unknown: '#d4d4d5',
		};

		let _start = moment(start_date);
		let _end = moment() > moment(end_date) ? moment(end_date) : moment();
		let phonesArray = _.intersectionBy(this.state.phoneStatus, this.state.phones, 'phone');
		let instagramsArray = _.intersectionBy(this.state.phoneStatus, this.state.instagrams, 'phone');
		_.each(phonesArray, function (it, s) {
			if (it.changes && it.changes.length) {
				_.each(it.changes, (a, i) => {
					let start = moment(a.date);
					let end = it.changes[i + 1] && it.changes[i + 1].date ? moment(it.changes[i + 1].date) : _end;

					if (i === 0 && start > _start) {
						let tooltip = moment.duration(start.diff(_start)).humanize();
						phoneTimeline.push([
							'' + it.phone,
							it.last_status || 'unknown',
							colorsphone[it.last_status || 'unknown'],
							`${'status'}: ${it.last_status || 'unknown'} <br/>${'Phone'}: ${it.phone}<br/>${'Duration'}: ${tooltip}`,
							_start,
							start,
						]);
					}
					let tooltip = moment.duration(end.diff(start)).humanize();
					phoneTimeline.push([
						'' + it.phone,
						a.status,
						colorsphone[a.status],
						`${'status'}: ${a.status} <br/>${'Phone'}: ${it.phone}<br/>${'duration'}: ${tooltip}`,
						start,
						end,
					]);
				});
			} else {
				let tooltip = moment.duration(_end.diff(_start)).humanize();
				phoneTimeline.push([
					'' + it.phone,
					it.last_status,
					colorsphone[it.last_status],
					`${'status'}: ${it.last_status} <br/>${'Phone'}: ${it.phone}<br/>${'duration'}: ${tooltip}`,
					_start,
					_end,
				]);
			}
		});
		_.each(instagramsArray, function (it, s) {
			if (it.changes && it.changes.length) {
				_.each(it.changes, (a, i) => {
					let start = moment(a.date);
					let end = it.changes[i + 1] && it.changes[i + 1].date ? moment(it.changes[i + 1].date) : _end;

					if (i === 0 && start > _start) {
						let tooltip = moment.duration(start.diff(_start)).humanize();
						instagramTimeline.push([
							'' + it.phone,
							it.last_status || 'unknown',
							colorsphone[it.last_status || 'unknown'],
							`${'status'}: ${it.last_status || 'unknown'} <br/>${'Phone'}: ${it.phone}<br/>${'Duration'}: ${tooltip}`,
							_start,
							start,
						]);
					}
					let tooltip = moment.duration(end.diff(start)).humanize();
					instagramTimeline.push([
						'' + it.phone,
						a.status,
						colorsphone[a.status],
						`${'status'}: ${a.status} <br/>${'Phone'}: ${it.phone}<br/>${'duration'}: ${tooltip}`,
						start,
						end,
					]);
				});
			} else {
				let tooltip = moment.duration(_end.diff(_start)).humanize();

				instagramTimeline.push([
					'' + it.phone,
					it.last_status,
					colorsphone[it.last_status],
					`${'status'}: ${it.last_status} <br/>${'Phone'}: ${it.phone}<br/>${'duration'}: ${tooltip}`,
					_start,
					_end,
				]);
			}
		});
		let main = [
			[
				{ type: 'string', id: 'Position' },
				{ type: 'string', id: 'Name' },
				{ type: 'string', role: 'style', id: 'style' },
				{ type: 'string', role: 'tooltip' },
				{ type: 'date', id: 'Start' },
				{ type: 'date', id: 'End' },
			],
		];
		let agentStatusList = _.concat(main, timelineData);
		let phoneStatusList = _.concat(main, phoneTimeline);
		/* let onlinePhones = _.filter(phoneTimeline, function (it) {
			return it[1] === 'active';
		}); */
		/* let phoneTable = [];
		let groupPhone = _.groupBy(onlinePhones, function (it) {
			return it[0];
		}); */
		let instagramStatusList = _.concat(main, instagramTimeline);
		let phoneLength = this.state.phones && this.state.phones.length;
		let instagramLength = this.state.instagrams && this.state.instagrams.length;
		return (
			<Container>
				<Segment>
					{/* <Table>
						<Table.Header>
							<Table.HeaderCell>Id</Table.HeaderCell>
							<Table.HeaderCell>Online Time</Table.HeaderCell>
							<Table.HeaderCell>Offline Time</Table.HeaderCell>
						</Table.Header>
						<Table.Body>
							<Table.Cell></Table.Cell>
						</Table.Body>
					</Table> */}
					{phoneLength ? (
						<div>
							<h3 style={{ textAlign: 'center' }}>Phones Timeline</h3>

							<Chart
								width={'100%'}
								height={(phoneLength + 2) * 39 + 'px'}
								chartType="Timeline"
								loader={<Page.Loader></Page.Loader>}
								errorElement
								data={phoneStatusList}
								rootProps={{ 'data-testid': '3' }}
							/>
						</div>
					) : null}
					{instagramLength ? (
						<div>
							<h3 style={{ textAlign: 'center' }}>Instagrams Timeline</h3>

							<Chart
								width={'100%'}
								height={(instagramLength + 2) * 39 + 'px'}
								chartType="Timeline"
								loader={<Page.Loader></Page.Loader>}
								errorElement
								data={instagramStatusList}
								rootProps={{ 'data-testid': '3' }}
							/>
						</div>
					) : null}
				</Segment>
				{process.env.NODE_ENV !== 'production' && (
					<div>
						<pre>{JSON.stringify(agentStatusList, null, 2)}</pre>
					</div>
				)}
			</Container>
		);
	}
}
const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product, user: state.access.user.loggedUserObj });

export default connect(stateToProps)(Analytic);
